import { render } from "./contareceber-editar.vue?vue&type=template&id=dc7105ea"
import script from "./contareceber-editar.vue?vue&type=script&lang=js"
export * from "./contareceber-editar.vue?vue&type=script&lang=js"

import "./contareceber-editar.vue?vue&type=style&index=0&id=dc7105ea&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__